import React, { useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import LabelTag from "../../../reusebale/label";
import ButtonTag from "../../../reusebale/button";
import { Check } from "lucide-react";
import db from "../../../../db/index.json";
import { useSelector, useDispatch } from "react-redux";
import { ShowError } from "../../../../utils/ToasFunction";
import { ShowSuccess } from "../../../../utils/ToasFunction";
import MyLoader from "../../../../component/reusebale/myLoader";
import BaseUrl from "../../../../constants/BaseUrl";
import * as AuthAction from "../../../../store/actions/auth/AuthAction";
const PersonalForm = (props) => {
  const { loginSuccess, userCompleteProfile } = useSelector(
    (state) => state.auth
  );
  const { completeProfileData } = db;
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [otploading, setOtpLoading] = useState(false);

  const [formFields, setFormFields] = useState({
    email: loginSuccess?.user?.email,
    firstName: loginSuccess?.user?.firstName,
    lastName: loginSuccess?.user?.lastName,
    tenantId: loginSuccess?.user?._id,
    emailVerified: false,
    phoneNumberVerified: userCompleteProfile?.personalInformation
      ? true
      : false,
    phoneNumber: loginSuccess?.user?.cellNo,
    profileImage:
      "https://img.freepik.com/free-photo/artist-white_1368-3546.jpg",

    phoneOpt: userCompleteProfile?.personalInformation ? "00000" : "",
    emailOtp: userCompleteProfile?.personalInformation ? "00000" : "",
    optSendShow: true,
  });

  const [optCodeSend, setOtpCodeSend] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const UpdateProfileInformation = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const raw = JSON.stringify({
      tenantId: formFields.tenantId,
      personalInformation: {
        firstName: formFields.firstName,
        lastName: formFields.lastName,
        email: formFields.email,
        emailVerified: true,
        phoneNumber: Number(formFields.phoneNumber),
        phoneNumberVerified: true,
      },
    });
    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}tenant/profile/createNewProfile`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setLoading(false);
          ShowSuccess("Personal Information updated successfully");
          dispatch(
            AuthAction.GetTenantProfile(
              loginSuccess?.user?._id,
              loginSuccess.token
            )
          );
        } else {
          setLoading(false);
          ShowSuccess(result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (userCompleteProfile.approvedStatus === "sendForApproval") {
      ShowError(
        "You cannot change anything on your profile unitil admin approved your request"
      );
    } else {
      if (!formFields.emailVerified) {
        ShowError("Please verify your email address first");
      } else if (formFields.firstName.length < 2) {
        ShowError("First name must be at least 2 characters long");
      } else if (formFields.lastName.length < 2) {
        ShowError("Last name must be at least 2 characters long");
      } else {
        UpdateProfileInformation();
      }
    }
  };

  const SendOtpCode = () => {
    setOtpLoading(true);
    setOtpCodeSend(false);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      to: loginSuccess?.user?.email,
      subject: "OTP Verification",
      message: "Test",
      _id: loginSuccess?.user?._id,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/email/sendEmailVerificationForTenant`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setOtpLoading(false);
          setOtpCodeSend(true);
          ShowSuccess(
            "OTP code successfully sent to the provided email address."
          );
        } else {
          setOtpLoading(false);
          setOtpCodeSend(false);
          ShowError("Oops! something went wrong.");
        }
      })
      .catch((error) => console.error(error));
  };
  const VerifyOtp = () => {
    setOtpLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      userId: loginSuccess?.user?._id,
      otpCode: formFields.emailOtp,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/email/verifyEmailOtpTenant`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setOtpLoading(false);
          ShowSuccess("Email address verified successfully");
          setFormFields({
            ...formFields,
            emailVerified: true,
          });
          setOtpVerified(true);
        } else {
          setOtpLoading(false);
          ShowError(result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <div className="bg-white rounded-xl">
      <div className="w-[95%] mx-auto py-8">
        <ParagraphTag
          content={completeProfileData?.PersonalInformation?.title}
          classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
        />

        <form className="mt-3">
          <div className="flex justify-between">
            <div className="w-[49%] mt-3">
              <LabelTag name={"Email Address"} className="text-black" />
              <div className="w-full relative">
                <input
                  disabled={formFields.phoneNumberVerified}
                  value={formFields.email}
                  type="text"
                  placeholder="Enter your email address"
                  className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
                />
                {!formFields.phoneNumberVerified && !otpVerified && (
                  <div className="absolute top-[6px] right-[2px]">
                    {otploading ? (
                      <div className="flex w-full justify-center items-center py-2">
                        <MyLoader size="w-5 h-5" />
                      </div>
                    ) : (
                      <ButtonTag
                        onSubmit={(e) => {
                          e.preventDefault();
                          SendOtpCode();
                          return;
                          ShowSuccess("OTP has sent successfully.");
                          setFormFields({
                            ...formFields,
                            optSendShow: false,
                          });
                        }}
                        name={
                          completeProfileData?.PersonalInformation?.phoneOtpSend
                        }
                        classes="text-xs px-2 bg-themeColor hover:bg-themeColor/90 text-center text-white"
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="w-[49%] mt-3">
              <LabelTag name="OTP" className="text-black" />
              <div className="w-full relative">
                <input
                  onChange={(e) => {
                    setFormFields({
                      ...formFields,
                      emailOtp: e.target.value,
                    });
                  }}
                  value={formFields.emailOtp}
                  type="number"
                  placeholder="Enter 4 digit OTP.."
                  className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
                />

                {optCodeSend && !otpVerified && (
                  <div className="absolute top-[6px] right-[2px]">
                    {otploading ? (
                      <div className="flex w-full justify-center items-center py-2">
                        <MyLoader size="w-5 h-5" />
                      </div>
                    ) : (
                      <ButtonTag
                        disabled={formFields.emailVerified}
                        onSubmit={(e) => {
                          e.preventDefault();
                          VerifyOtp();
                          return;

                          if (formFields.emailOtp === "") {
                            ShowError("Otp cannot be empty");
                          } else if (formFields.emailOtp === "12345") {
                            ShowSuccess("Email address verified successfully");
                            setFormFields({
                              ...formFields,
                              emailVerified: true,
                            });
                          }
                        }}
                        name={
                          formFields.phoneNumberVerified ? "verified" : "verify"
                        }
                        classes={`text-xs px-2 ${
                          formFields.phoneNumberVerified
                            ? "bg-green-600"
                            : "bg-themeColor"
                        }  hover:bg-themeColor/90 text-center text-white`}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-between">
            <div className="w-[49%] mt-3">
              <LabelTag
                name={completeProfileData?.PersonalInformation?.lable2}
                className="text-black"
              />
              <input
                value={formFields?.firstName}
                type="text"
                placeholder="Enter your first name.."
                className="w-full mt-1 text-sm font-popinsRegular bg-bgColor px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
              />
            </div>
            <div className="w-[49%] mt-3">
              <LabelTag
                name={completeProfileData?.PersonalInformation?.lable3}
                className="text-black"
              />
              <input
                value={formFields?.lastName}
                type="text"
                placeholder="Enter your email last name.."
                className="w-full mt-1 text-sm font-popinsRegular bg-bgColor px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
              />
            </div>
          </div>

          <div className="flex justify-between">
            <div className="w-[49%] mt-3">
              <LabelTag
                name={completeProfileData?.PersonalInformation?.lable5}
                className="text-black"
              />
              <div className="w-full relative">
                <input
                  onChange={(e) => {}}
                  value={formFields.phoneNumber}
                  type="text"
                  placeholder="Enter your Phone Number.."
                  className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
                />
                <div className="absolute top-[6px] right-[2px]">
                  {/* <ButtonTag
                    disabled={formFields.phoneNumberVerified}
                    onSubmit={(e) => {
                      e.preventDefault();
                      ShowSuccess("OTP has sent successfully.")
                      setFormFields({
                        ...formFields,
                        optSendShow: false
                      })
                    }}

                    name={completeProfileData?.PersonalInformation?.phoneOtpSend}
                    classes={`text-xs px-2 bg-themeColor hover:${formFields.phoneNumberVerified ? "bg-black/90" : ":bg-themeColor/90"}  text-center text-white ${formFields.phoneNumberVerified ? "bg-gray-200" : "bg-themeColor"}`}
                  /> */}
                </div>
              </div>
            </div>
            {/* <div className="w-[49%] mt-3">
              <LabelTag name="OTP" className="text-black" />
              <div className="w-full relative">
                <input
                  disabled={formFields.phoneNumberVerified}
                  onChange={(e) => {
                    setFormFields({
                      ...formFields,
                      phoneOpt: e.target.value
                    })
                  }}
                  value={formFields.phoneOpt}
                  type="text"
                  placeholder="Enter 4 digit OTP.."
                  className="w-full mt-1 font-popinsRegular bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor placeholder:text-zinc-700/50 pr-16"
                />
                <div className="absolute top-[6px] right-[2px]">
                  <ButtonTag
                    disabled={formFields.phoneNumberVerified}
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (formFields.phoneOpt === "") {
                        ShowError("Otp cannot be empty")
                      } else if (formFields.phoneOpt === "12345") {
                        ShowSuccess("Cell number verified successfully")
                        setFormFields({
                          ...formFields,
                          phoneNumberVerified: true
                        })
                      }
                    }}
                    name={formFields.phoneNumberVerified ? "verified" : "verify"}
                    classes={`text-xs px-2 ${formFields.phoneNumberVerified ? 'bg-green-600' : "bg-themeColor"}  hover:bg-themeColor/90 text-center text-white`}
                  />
                </div>
              </div>
            </div> */}
          </div>
          <div className="w-full bg-themeColor text-white mt-5 rounded-md">
            {loading ? (
              <div className="flex w-full justify-center items-center py-2">
                <MyLoader />
              </div>
            ) : (
              <>
                {!userCompleteProfile?.personalInformation && (
                  <ButtonTag
                    disabled={
                      userCompleteProfile?.personalInformation ? true : false
                    }
                    onSubmit={submitHandler}
                    name={
                      userCompleteProfile?.personalInformation ? "Save" : "Save"
                    }
                  />
                )}
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default PersonalForm;
